module.exports = __webpack_public_path__ + "static/media/EI.44ce9e15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/EI.svg
// module id = 87
// module chunks = 0